// extracted by mini-css-extract-plugin
export var emailBlockLink = "_l9-0";